import React, { createContext, useContext, useMemo, useState } from "react";

const HelpContext = createContext({ currentViewId: null, setCurrentViewId: () => {} });

export function HelpContextProvider({ children }) {
  const [currentViewId, setCurrentViewId] = useState(null);
  const value = useMemo(() => ({ currentViewId, setCurrentViewId }), [currentViewId]);
  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
}

export const useHelpContext = () => useContext(HelpContext);
